<template>
  <v-dialog
  v-model="descriptionDialog"
  persistent
  :disabled="!isPermission"
  width="1000px">
    <v-btn outline small class="UXbtn small whiteBtn" :disabled="!isPermission"
           slot="activator" @click="getAgentsCounselingStatus">担当者へ割当
    </v-btn>
    <div class="layerPopup managerDist">
      <div class="layerTit">担当者へ割当</div>
      <div class="layerContent">
        <div class="transferLayerCon">
          <div class="in">
            <div class="box" style="padding-top: 6px">
              <dl>
                <dt style="text-align: right; color: #919191">*データ基準 : 当日 00:00 ~ 24:00</dt>
                <dd class="header">
                  <div>(ステータス）オペレーター名</div>
                  <div>対応状況</div>
                </dd>
                <dd>
                  <VuePerfectScrollbar class="userScroll larger scrollBoxCustom">
                    <table class="distTblCon">
                      <colgroup>
                        <col style="width:5%">
                        <col>
                        <col style="width:13%">
                        <col style="width:11%">
                        <col style="width:11%">
                        <col style="width:13%">
                        <col style="width:13%">
                      </colgroup>
                      <tr v-for="(item, index) in agentsCounselingStatus" :key="index" :class="{'on': selectedAgentId === item.agentId}" @click="selectAgent(item.agentId)">
                        <td>
                          <v-radio-group class="UXradio" v-model="selectedAgentId" hide-details>
                            <v-radio :value="item.agentId"></v-radio>
                          </v-radio-group>
                        </td>
                        <td>
                          <div>
                            <!--<div class="onlineIcon"></div>-->
                            <!--상담사 이름 툴팁-->
                            <span>({{ item.workingStatus}}) {{item.agentName}}</span>
                          </div>
                        </td>
                        <td class="countDt">割当 <span>{{ item.assignChatRoomCt }}</span></td>
                        <td class="countDt">対応中 <span>{{ item.activeChatRoomCt }}</span></td>
                        <td class="countDt">後処理 <span>{{ item.summaryWaitingChatRoomCt }}</span></td>
                        <td class="countDt">終了 <span>{{ item.completeChatRoomCt }}</span></td>
                        <td class="countDt">転送 <span>{{ item.takeOverRoomCt }}</span></td>
                      </tr>
                    </table>
                    <div v-if="agentsCounselingStatus.length === 0" class="UXnotData larger" style="height: 370px;">担当者として指定可能なオペレーターがいません。</div>
                  </VuePerfectScrollbar>
                </dd>
                <dt style="margin-top: 20px; color: #919191">担当者へのメッセージ (<span class="blue-6">{{calcByte}}</span>/1000)</dt>
                <dd>
                  <v-textarea
                    v-model="distributionDescription"
                    hide-details
                    no-resize
                    outline
                    height="145"
                    class="UXtextarea"
                    maxlength="1000"
                    placeholder="内容を入力してください。"
                  ></v-textarea>
                </dd>
                <div class="cenBtn">
                  <v-btn outline round class="UXbtn" @click.native="initializeDistributionDashboard">キャンセル</v-btn>
                  <v-btn round dark color="#ff8c8c" class="UXbtn" :loading="loading" @click.native="assignChatRoomByManager">確認</v-btn>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="layerClose">
        <v-btn flat icon @click="initializeDistributionDashboard">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import helper from 'util/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'manager_distribution_dashboard',
  props: {
    chatRoomId: {
      type: Number
    },
    isManagerAssignChatRoom: {
      type: Boolean
    },
    isPermission: {
      type: Boolean
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      agentsCounselingStatus: [],
      descriptionDialog: '',
      selectedAgentId: 0,
      distributionDescription: '',
      loading: false,
      roomInfo: {name: '', customerInfoView: {name: ''}},
      calcByte: 0,
      isNoBodyAgent: false,
      informationMessage: ['読み込み中です。しばらくお待ちください。']
    }
  },
  watch: {
    loading () {
      this.getInformationMessage()
    },
    distributionDescription () {
      this.calcByte = this.distributionDescription.length
    }
  },
  created () {
    this.roomInfo = helper.findByChatRoomId(this.chatRoomTabList, this.chatRoomId)
  },
  computed: {
    ...mapGetters([
      'agentId',
      'loginId',
      'findCustomerName',
      'findCustomerPhoneNumber',
      'findCustomerFullName',
      'chatRoomTabList',
      'inputAreaHeightLevel',
      'alarmedChatRoomId',
      'markedChatRoom',
      'activeChatRoomList',
      'completeChatRoomList',
      'summaryChatRoomList',
      'transferredChatRoomList',
      'displayingChatRoomId',
      'allChatRoomList',
      'mallId',
      'isPossibleWaitingCategory'
    ]),
    displayingChatRoomId () {
      return this.$store.getters.displayingChatRoomId
    },
    isDisplaying () {
      return this.displayingChatRoomId === this.chatRoomId
    }
  },
  methods: {
    ...mapMutations([
      'deleteToActiveChatRoomList',
      'deleteTabChatRoom',
      'removeTransferChatRooms',
      'addSummaryChatRoom'
    ]),
    selectAgent (agentId) {
      this.selectedAgentId = agentId
    },
    getAgentsCounselingStatus () {
      // 담당자 할당이 가능한 방일경우
      if (this.isManagerAssignChatRoom) {
        this.loading = true
        this.axios.get('/api/chat/agentsChatRoomCount', {
          params: {
            chatRoomId: this.chatRoomId
          }
        }).then(result => {
          this.loading = false
          if (result.data.code !== 0) {
            this.isNoBodyAgent = true
            this.$alertMsg(result.data.message)
            return
          }
          this.agentsCounselingStatus = result.data.data
          if (this.agentsCounselingStatus.length < 1) {
            this.isNoBodyAgent = true
          }
        })
      } else {
        this.$alertMsg('担当者へ割当が不可能な相談ルームまたはオペレーターです。')
      }
    },
    initializeDistributionDashboard () {
      this.descriptionDialog = false
      this.selectedAgentId = 0
      this.distributionDescription = ''
      this.agentsCounselingStatus = []
      this.calcByte = 0
      this.isNoBodyAgent = false
    },
    assignChatRoomByManager () {
      this.loading = true
      this.axios.post('/api/chat/assignByManager', {
        agentId: this.agentId,
        chatRoomId: this.chatRoomId,
        nextAgentId: this.selectedAgentId,
        takeOverMemo: this.distributionDescription
      }).then(res => {
        this.loading = false
        if (res.data.code !== 0) {
          this.$alertMsg(res.data.message)
          return
        }
        this.initializeDistributionDashboard()
      })
    },
    convertAgentName (name) {
      if (name.length > 8) {
        return name.substring(0, 8) + '...'
      }
      return name
    },
    getInformationMessage () {
      if (this.isNoBodyAgent) {
        this.informationMessage = ['担当者へ割当を受けるオペレーターがいません。']
      } else {
        this.informationMessage = ['読み込み中です。しばらくお待ちください。']
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.blue-6 {
  color: #ff8c8c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/manager_distribution_dashboard.vue